<template>
	<vue-scroll>
		<div id="page-contacts" class="page-addtransaction scrollable only-y"
			v-show="userPermissionsFilter.completetransactions" v-loading="pageLoading"
			:element-loading-text="loadingText" element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)">
			<resize-observer @notify="__resizeHanlder" />
			<div class="col-xs-12 col-md-12 p-10" style="background-color: #F5B041;">
				<h2 style="line-height: 1;padding-bottom: 1px;margin-bottom: 5px;">Retreive Unpaid Customer Transaction
				</h2>
				<div id="plug">
					<div v-if="showTimer" class="v" style="color:red">We are moving this module to <a
							:href=newbackofficeurl target="_blank">New
							Backoffice</a>. This module will be permanently disabled in {{ timerOutput }}</div>
					<div v-else class="v"></div>
				</div>
				<el-row>
					<el-col :span="16">
						<span>Search Unpaid Customer Transaction</span>
						<el-select class="col-xs-12 col-md-7" style="width: 99%;float:right" v-model="selectedSender"
							filterable clearable remote reserve-keyword
							placeholder="Search using Transaction Reference Number" :remote-method="remoteMethod"
							:loading="loading" @change="openDialog">
							<el-option v-for="item in options4" :key="item.referenceNumber"
								:label="`${item.referenceNumber} - ${item.firstName} ${item.lastName} - ${item.receiverCountry} - (${formatShortDate(item.createdOn)})`"
								:value="item"></el-option>
						</el-select>
					</el-col>
				</el-row>
			</div>


			<!-- <div class="table-responsive" v-show="userPermissionsFilter.viewtransactions">
					<table class="table" id="datatable" style="color:white;">
						<thead >
							<tr>
								<th>Reference</th>
								<th>Sender Name</th>
								<th>senderAmount</th>
								<th>Provider</th>
								<th>Transaction Date</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in transactionsdata" :key="item.email">
								<td>{{item.referenceNumber}}</td>
								<td>{{item.firstName}} {{item.middleName}} {{item.lastName}}</td>
								<td>{{item.senderAmount}}</td>
								<td>{{item.providerName}}</td>
								<td>{{formatShortDate(item.createdOn)}}</td>
							</tr>
						</tbody>
					</table>
			</div> -->



			<!-- <div class="contacts-root box grow flex gaps justify-center" :class="contactsClass">
					<div class="card-base card-shadow--small search-card scrollable only-y">
						<h1 class="mt-0 pageTitle">Complete Transaction</h1>
						<el-input
							prefix-icon="el-icon-search"
							placeholder="Search a Transaction"
							clearable
							v-model="search">
						</el-input>
					</div>

					<div class="contacts-list box grow scrollable only-y">
						<div v-for="c in usersFiltered" :key="c.transactionID" class="flex contact" @click="openDialog(c)">
							<div class="info box grow flex" v-show="c.mpesaCode == null">
								<div class="name box grow flex column justify-center p-10">
									<div class="fullname fs-18 text-white"><strong>{{c.referenceNumber}} <span v-show="c.globalApiRef !=null"> ({{c.globalApiRef}})</span></strong></div>
									<div class="phone fs-14 secondary-text">
										{{c.senderAmount}}
									</div>
									<div class="email fs-14 secondary-text accent-text">{{c.createdOn}}</div>
								</div>
								<div class="phone align-vertical p-10"><span class="align-vertical-middle">{{c.firstName}} {{c.middleName}} {{c.lastName}}</span></div>
							</div>
						</div>
					</div>
				</div> -->


			<el-dialog :show-close="true" :custom-class="'user-dialog'" :visible="dialogFormVisible"
				@close="closeDialog" :before-close="handleClose">
				<div class="form-box">
					<div class="row">
						<div class="row mt-12">
							<div class="col col-md-12"><strong>Customer Name: </strong>{{ transactiondata.firstName }}
								{{ transactiondata.middleName }} {{ transactiondata.lastName }}</div>
						</div>
						<div class="row mt-12">
							<div class="col col-md-12"><strong>Upesi Ref: </strong>{{ transactiondata.referenceNumber }}
							</div>
						</div>
						<div class="row mt-12">
							<div class="col col-md-12"><strong>Amount: </strong> {{ transactiondata.senderCurrency }}
								{{ formatPrice(transactiondata.senderAmount) }}</div>
						</div>
						<div class="row mt-12">
							<div class="col col-md-12"><strong>Receiving Country:
								</strong>{{ transactiondata.receiverCountry }}</div>
						</div>
						<div class="row mt-12">
							<div class="col col-md-12"><strong>Transaction Date:
								</strong>{{ formatShortDate(transactiondata.createdOn) }}</div>
						</div>
						<div class="row mt-12">
							<div class="col col-md-12">
								<strong>Mpesa Code/ Bank Ref</strong>
								<el-input placeholder="Mpesa Code/ Bank Ref" v-model="paymentDetails.MpesaCode"
									name="MpesaCode" v-validate="'required'" data-vv-as="MpesaCode"></el-input>
								<transition name="fade">
									<span class="danger-text">{{ errors.first('MpesaCode') }}</span>
								</transition>
							</div>
						</div>
						<div class="row mt-12">
							<div class="col col-md-12">
								<strong>Collection Mode</strong>
								<el-select v-model="paymentDetails.collectionMode" filterable clearable
									placeholder="Collection Mode" style="width:100%" name="collectionMode"
									v-validate="'required'" data-vv-as="Mode of Collection">
									<el-option v-for="mode in collectionModes" :key="mode.id" :label="mode.synonym"
										:value="mode.code"></el-option>
								</el-select>
							</div>
						</div>

						<div class="row mt-12"
							v-show="transactiondata.transactionID != null && userPermissionsFilter.completetransactions">
							<div class="col col-md-12">
								<el-button type="success" class="btn-group" style="width:30%" @click="pushTransaction">
									<i class="mdi mdi-account-check"></i><span> Push Transaction</span>
								</el-button>
							</div>
						</div>
					</div>
				</div>
			</el-dialog>
		</div>
	</vue-scroll>
</template>

<script>
import { newbackofficeurl } from "../../package.json";

import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"

import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import $ from 'jquery';

import PermissionsMixin from '@/mixins/PermissionsMixins'

export default {
	name: 'transactions',
	data() {
		return {
			selectedSender: "",
			options4: [],
			search: '',
			pageWidth: 0,
			size: 5,
			collectionModes: [],
			transactiondata: '',
			transactionsdata: '',
			paymentDetails: {
				collectionMode: "",
				TransactionID: '',
				MSISDN: '',
				MpesaCode: '',
			},

			newbackofficeurl: "",
			countDownToTime: new Date('Nov 12, 2024 00:00:00').getTime(),
			timerOutput: '',
			showTimer: true
		}
	},
	computed: {
		usersFiltered() {
			//console.log(this.users);
			return this.users.filter(({ referenceNumber, senderAmount, firstName, receiverCountry }) => (referenceNumber + senderAmount + firstName + receiverCountry).toString().toLowerCase().indexOf(this.search.toString().toLowerCase()) !== -1)
		},
		contactsClass() {
			return this.pageWidth >= 870 ? 'large' : this.pageWidth >= 760 ? 'medium' : 'small'
		},
		readOnlyMode() {
			return !this.userPermissionsFilter.addusers && !this.userPermissionsFilter.editusers;
		}
	},
	methods: {
		openDialog(data) {
			if (data) {
				this.dialogFormVisible = true;
				this.transactiondata = data;
				this.paymentDetails.TransactionID = data.transactionID;
			}
		},
		setPageWidth() {
			this.pageWidth = document.getElementById('page-contacts').offsetWidth
		},
		__resizeHanlder: _.throttle(function (e) {
			this.setPageWidth()
		}, 700),
		remoteMethod(query) {
			this.options4 = [];
			if (query.length > 4) {
				this.loading = true;
				this.loading = false;
				this.getPendingTransactionsReport(this.size, query).then((result) => {
					if (result) {
						this.options4 = result;

						// $("#datatable").dataTable().fnDestroy();
						// this.transactionsdata = result;
						// this.$nextTick(function() {
						// 	this.initDt()
						// });
						this.stopLoader();
					}
				}).catch(err => { this.errorMessage("An Error Occured. " + err); this.stopLoader(); });
			} else {
				this.options4 = [];
			}
		},
		initDt() {
			var cmp = this.loggedInCompany.name + " Transactions";
			var cmp_logo = this.loggedInCompany.logo;
			$('#datatable').DataTable({
				retrieve: true,
				dom: 'Blfrtip',
				"aaSorting": [],
				buttons: [
					// {
					// 	extend : 'pdfHtml5',
					// 	title : function() {
					// 		return cmp;
					// 	},
					// 	orientation : 'landscape',
					// 	pageSize : 'A3', // You can also use "A1","A2" or "A3", most of the time "A3" works the best.
					// 	text : '<i class="fa fa-file-pdf-o"> PDF</i>',
					// 	titleAttr : 'PDF',
					// 	messageBottom: 'This report was generated By '+this.loggedInUser,
					// 	customize: function ( doc ) {
					// 		doc.content.splice( 1, 0, {
					// 			margin: [ 0, 0, 0, 10 ],
					// 			alignment: 'center',
					// 			image: cmp_logo
					// 		} );
					// 	}
					// },
					{
						extend: 'print',
						orientation: 'landscape',
						pageSize: 'A3', // You can also use "A1","A2" or "A3", most of the time "A3" works the best.
						customize: function (doc) {
							doc.content.splice(1, 0, {
								margin: [0, 0, 0, 10],
								alignment: 'center',
								image: cmp_logo
							});
						}
					}
					// {
					// 	extend: 'csv',
					// 	//messageTop: cmp,
					// 	title : function() {
					// 		return cmp;
					// 	},
					// 	messageBottom: 'This report was generated By '+this.loggedInUser,
					// },
					// {
					// 	extend: 'excel',
					// 	title : function() {
					// 		return cmp;
					// 	},
					// 	messageBottom: 'This report was generated By '+this.loggedInUser,
					// },
				],
				initComplete: function () {
					var api = this.api();
					api.columns(4).every(function () {
						var column = this;
						var select = $('<select><option value="">Filter Kyc Status</option></select>')
							.appendTo($(column.footer()).empty())
							.on('change', function () {
								var val = $.fn.dataTable.util.escapeRegex(
									$(this).val()
								);

								column
									.search(val ? '^' + val + '$' : '', true, false)
									.draw();
							});

						column.data().unique().sort().each(function (d, j) {
							select.append('<option value="' + d + '">' + d + '</option>')
						});
					});
				},
			});
		},

		fetchTransactions() {
			this.startLoader("Getting Pending Transactions...");
			this.getPendingTransactions().then((result) => {
				this.stopLoader();
			}).catch(err => { this.errorMessage("An Error Occured. " + err); this.stopLoader(); });

		},

		pushTransaction() {
			if (!this.paymentDetails.MpesaCode) {
				this.errorMessage('Mpesa Code is Missing.');
			}
			if (!this.paymentDetails.collectionMode) {
				this.errorMessage('Collection mode is Missing.');
			}
			if ((this.paymentDetails.MpesaCode) && (this.paymentDetails.collectionMode)) {
				this.$confirm('Are you sure to push this transaction?').then(_ => {
					//this.processingActive();
					this.savePaymentInfo(this.paymentDetails).then(result => {
						if (result) {
							this.dialogFormVisible = false;
							this.successMessage('Transaction Was Pushed Successifully.');
							this.paymentDetails.MpesaCode = '';
							this.options4 = [];
							//this.fetchTransactions();
							router.push("/approveBackofficeTransaction");
						}
						else {
							this.errorMessage('Failed to push Transaction.');
						}
					});
				}).catch(_ => { });
			}
		},
	},
	mounted() {
		this.getLoggedInCompany()
			.then((loggedInCompany) => {
				this.getCollectionModes(loggedInCompany.id).then((result) => {
					this.collectionModes = result;
				});
			});
		//this.fetchTransactions();
		this.setPageWidth()
	},
	created() {
		this.startTimer();
		let self = this;
		this.newbackofficeurl = self.$newbackofficeurl;
	},
	mixins: [PermissionsMixin]
}
</script>